import { render } from "./ClockDrawingAdminister.vue?vue&type=template&id=5aa8b25a&scoped=true"
const script = {}

import "./ClockDrawingAdminister.vue?vue&type=style&index=0&id=5aa8b25a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa8b25a"]])

export default __exports__